import { i18next } from '@frontend/i18n';

export const productionValueDefinition = (multiplier: number, dateRangeHelperText?: string) =>
  i18next.t(
    'Production Value is calculated by multiplying the total number of completed appointments {{dateRangeHelperText}} by ${{multiplier}}',
    {
      dateRangeHelperText,
      multiplier,
      ns: 'analytics',
    }
  );
